var wholesaler = new Vue({
    el:'#wholesaler',
    data:function(){
        return{
            nav:['Become a wholesaler','Get Free Sample','Free Materials'],
            navIndex:0,
            info1:{
                name:'',
                Identity:'Identity',
                company:'',
                email:'',
                phone:'',
                country:'Country',
                province:'',
                city:'',
                message:''
            },
            info2:{
                name:'',
                Identity:'Identity',
                company:'',
                email:'',
                phone:'',
                country:'Country',
                message:'',
                link:'',
                fans:'',
                city:'',
                province:'',
                code:''
            },
            info3:{
                name:'',
                email:'',
                phone:'',
                country:'Country',
                city:'',
                province:'',
                store:'',
                number:'',
                product:'',
                like:''
            },
            select1:['Distributor','Shop owner'],
            select2:['Distributor','Shop owner','Influencer'],
            select_flag1:0,
            select_flag2:0,
            select_flag3:0,
            select_flag4:0,
            select_flag5:0,
            popup1:false,
            popup2:false,
            popup3:false,
            popup4:false,
            popup5:false,
            countryArr:[],
            data1:[],
            data2:[],
            data3:[],
            submitFlag:true,
            uploadFlag:false,
            findText:'',
        }
    },
    methods:{
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                    country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );
        
            if (targetCountry) {
                // 滚动到目标国家
                //targetCountry.scrollIntoView({ block: 'start' });
                // 让父容器内部滚动，而不是整个页面滚动
                countryList.scrollTop = targetCountry.offsetTop;
            }
        },
        async submit1(event){
            if(!this.submitFlag){
                //不能重复提交 
                event.preventDefault();  
                return;
            }
            if(this.info1.name==''||this.info1.company==''||this.info1.email==''||this.info1.phone==''||this.info1.message==''||
            this.info1.Identity=='Identity'||this.info1.country=='Country'||this.info1.province==''||this.info1.city==''){
                showMessage('Please fill in the information completely','error')
            }else if(this.data1.length==0){
                showMessage('Please upload pictures','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.info1.email)){
                    showMessage('Sent successfully','success')
                    this.submitFlag = false
                    //上传文件
                    const formData = new FormData();
                    for(var i=0;i<this.data1.length;i++){
                        formData.append("files", this.data1[i]);
                    }
                    let res=await axios.post('https://service.oxvatech.cn/email/upload',formData,{headers: {
                        'Content-Type': 'multipart/form-data'
                    }});

                    if(res.status==200){
                        let filesArr = res.data.files;
                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.info1));
                        params.append('filesArr',JSON.stringify(filesArr));
                        let result=await axios.post('https://service.oxvatech.cn/email/wholesaler',params);
                        if(result.status == 200){
                            window.location.reload()
                        }
                    }
                }else{
                    showMessage('Email format error','error')
                }
            }
        },
        async submit2(event){
            if(!this.submitFlag){
                //不能重复提交 
                event.preventDefault();  
                return;
            }
            if(this.info2.name==''||this.info2.company==''||this.info2.email==''||this.info2.phone==''||this.info2.message==''||
                this.info2.Identity == 'Identity'||this.info2.country=='Country'||this.info2.city==''||this.info2.province==''){
                    showMessage('Please fill in the information completely','error')
                    return;
            }
            if(this.info2.Identity == 'Influencer'){
                if(this.info2.code==''||this.info2.link==''||this.info2.fans==''){
                    showMessage('Please fill in the information completely','error')
                    return;
                }
            }
            if(this.data2.length==0){
                showMessage('Please upload pictures','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.info2.email)){
                    showMessage('Sent successfully','success')
                    this.submitFlag = false
                    //上传文件
                    const formData = new FormData();
                    for(var i=0;i<this.data2.length;i++){
                        formData.append("files", this.data2[i]);
                    }
                    let res=await axios.post('https://service.oxvatech.cn/email/upload',formData,{headers: {
                        'Content-Type': 'multipart/form-data'
                    }});

                    if(res.status==200){
                        let filesArr = res.data.files;
                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.info2));
                        params.append('filesArr',JSON.stringify(filesArr));
                        let result=await axios.post('https://service.oxvatech.cn/email/sample',params);
                        if(result.status == 200){
                            window.location.reload()
                        }
                    }
                }else{
                    showMessage('Email format error','error')
                }
            }
            
        },
        async submit3(event){
            if(!this.submitFlag){
                //不能重复提交 
                event.preventDefault();  
                return;
            }
            if(this.info3.name==''||this.info3.country=='Country'||this.info3.email==''||this.info3.phone==''||this.info3.store==''||
            this.info3.number==''||this.info3.product==''||this.info3.like==''||this.info3.city==''||this.info3.province==''){
                showMessage('Please fill in the information completely','error')
            }else if(this.data3.length==0){
                showMessage('Please upload pictures','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.info3.email)){
                    showMessage('Sent successfully','success')
                    this.submitFlag = false
                    //上传文件
                    const formData = new FormData();
                    for(var i=0;i<this.data3.length;i++){
                        formData.append("files", this.data3[i]);
                    }
                    let res=await axios.post('https://service.oxvatech.cn/email/upload',formData,{headers: {
                        'Content-Type': 'multipart/form-data'
                    }});
                    
                    if(res.status==200){
                        let filesArr = res.data.files;
                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.info3));
                        params.append('filesArr',JSON.stringify(filesArr));
                        let result=await axios.post('https://service.oxvatech.cn/email/materials',params);
                        if(result.status == 200){
                            window.location.reload()
                        }
                    }
                }else{
                    showMessage('Email format error','error')
                }
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        upload(event){
            var id = Number(this.navIndex) + 1;
            var file = event.target.files[0]
            if(file.size>10*1024*1024){
                showMessage('The uploaded file cannot exceed 10M','error')
                return;
            }else if(this[`data${id}`].length==9){
                showMessage('Upload up to 9 files','error')
                return;
            }else{
                this[`data${id}`].push(file)
            }
        }
    },
    created(){
        let href_id = window.location.href
        if (href_id.indexOf('?id') !== -1 ) {
            let query = href_id.substring(href_id.indexOf('?') + 4);
            if(query==1 || query ==2){
                this.navIndex = query
            }
        }
    },
    mounted(){
        this.getCountry()
    }
})

$(document).on("click", function(e) {
    var container = $(".wcr_select");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        wholesaler.$data.popup1 = wholesaler.$data.popup2 = wholesaler.$data.popup3 = wholesaler.$data.popup4 = wholesaler.$data.popup5 = false
    }
});